import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

const PrivateRoute = ({ children }) => {
  const { instance } = useMsal(); // Microsoft
  const { loading, isAuthenticated } = useAuth();

  const activeMicrosoftUser = instance?.getActiveAccount();

  const Authenticated = !!isAuthenticated || !!activeMicrosoftUser;

  if (loading) return <div>Loading...</div>;

  return Authenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;
